import { render } from "./TheEventList.vue?vue&type=template&id=6ca78dae&scoped=true&ts=true&lang=html"
import script from "./TheEventList.vue?vue&type=script&lang=ts"
export * from "./TheEventList.vue?vue&type=script&lang=ts"

import "./TheEventList.vue?vue&type=style&index=0&id=6ca78dae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca78dae"]])

export default __exports__